export const CPG_TOOLTIP_TEXT =
  'Consumer packaged goods (CPGs) - goods that customers use up and replace on a frequent basis (e.g. food, beverages, cosmetics, and cleaning products).'
